module.exports = __webpack_public_path__ + "src/assets/img/engine_four.08beeee2.svg";